/** Shared organisation switcher helpers (no React / Vite env deps). */

import type { Organisation } from '@/hooks/use-organisations'

export function organisationSwitcherAcronym(name: string, maxChars = 3): string {
  const t = name.trim()
  if (!t) return '?'
  const words = t.split(/\s+/).filter(Boolean)
  if (words.length === 1) {
    return words[0].slice(0, maxChars).toUpperCase()
  }
  const initials = words
    .slice(0, maxChars)
    .map((w) => w[0] ?? '')
    .join('')
  return initials.toUpperCase() || words[0].slice(0, maxChars).toUpperCase()
}

export function sortOrganisationsForMenu(
  organisations: Organisation[],
  activeSlug: string | null,
): Organisation[] {
  const active = organisations.filter((o) => o.slug === activeSlug)
  const rest = organisations
    .filter((o) => o.slug !== activeSlug)
    .sort((a, b) => a.name.localeCompare(b.name))
  return [...active, ...rest]
}

/** Legacy user-settings billing route — redirects to org settings billing. */
export function isLegacyUserSettingsBillingPath(pathname: string): boolean {
  const normalized = pathname.replace(/\/+$/, '') || '/'
  return normalized === '/settings/billing'
}
